export default __webpack_public_path__ + "static/media/more-dots.d4be70d7.svg";